module.exports = __webpack_public_path__ + "img/purchases--icon.e07f7663.svg";